import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import vi from '@angular/common/locales/vi';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router, RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { NgSelectModule } from '@ng-select/ng-select';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { TranslateService } from '@ngx-translate/core';
import { SwiperModule } from 'swiper/angular';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DrawerComponent } from './components/drawer/drawer.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { RegisterErrorComponent } from './components/register-form-popup/register-error/register-error.component';
import { RegisterFormPopupComponent } from './components/register-form-popup/register-form-popup.component';
import { RegisterSuccessComponent } from './components/register-form-popup/register-success/register-success.component';
import { SelectBoxModule } from './components/select-box/select-box.module';
import { ApiAuthorizeService } from './core/_authentication/api-authorize.service';
import { AuthInterceptorProviders } from './core/_interceptor/auth.interceptor';
import { MasterComponent } from './core/_layout/master/master.component';
import { NgxTranslateModule } from './core/_modules/translate/translate.module';
import { CategoryService } from './core/_services/category.service';
import { ConfigurationService } from './core/_services/configuration.service';
import { NavigationService } from './core/_services/navigation.service';
import { RouteCustomService } from './core/_services/route-custom.service';
import { StateService } from './core/_services/state.service';
import { jwtOptions } from './core/_utils/common-function.util';

registerLocaleData(vi);

const requestTokenProcess = (
  stateService: StateService,
  routeCustom: RouteCustomService,
  apiAuthorize: ApiAuthorizeService,
  navService: NavigationService,
  cateService: CategoryService,
  configService: ConfigurationService,
  router: Router,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  translate: TranslateService,
) => {
  return async () => {
    // const config = await navService.getConfig();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const t = await apiAuthorize.requestToken();
    const languages = await navService.getAllLanguages();
    if (router && router.url) {
      let urlPath = router.url?.split('/');
      if (location) {
        urlPath = location.pathname?.split('/');
      }
      if (urlPath && urlPath[1]) {
        for (const lang of languages) {
          if (lang.code === urlPath[1]) {
            stateService.currentLanguage$.next(lang.code);
          }
        }
      }
    }
    const currentLanguage = stateService.currentLanguage$.getValue();
    const [tree] = await Promise.all([navService.getNavigationForHeader(), cateService.getAll()]);
    routeCustom.createTree(navService, cateService, currentLanguage, router, tree);
    return '';
  };
};

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    DrawerComponent,
    FooterComponent,
    RegisterFormPopupComponent,
    RegisterSuccessComponent,
    RegisterErrorComponent,
    MasterComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    TransferHttpCacheModule,
    AppRoutingModule,
    HttpClientModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    BrowserAnimationsModule,
    SwiperModule,
    NgSelectModule,
    SelectBoxModule,
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptions.options,
      },
    }),
    NgxTranslateModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'vi-VN' },
    {
      provide: APP_INITIALIZER,
      useFactory: requestTokenProcess,
      deps: [
        StateService,
        RouteCustomService,
        ApiAuthorizeService,
        NavigationService,
        CategoryService,
        ConfigurationService,
        Router,
        TranslateService,
      ],
      multi: true,
    },
    AuthInterceptorProviders,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
